import { AuthSource, setAuthGlobalOptions } from '@framework/auth';

setAuthGlobalOptions({
  requiresRoleSelection: false,
  storageKey: 'fwpfoauth',
  source: AuthSource.FrontOffice,
  // L'utente con PG associate resta `isPrelogged` finché non ha scelto "per
  // conto di" (profiloSelezionato valorizzato). Vedi LoginPage.
  requiresLegalEntitySelection: true,
});
